/* eslint-disable typescript-sort-keys/string-enum */
// Custom Typings
import { PropsWithChildren } from 'react';

export type ValueOf<T> = T[keyof T];

export enum EvtKeys {
  Backspace = 'Backspace',
  Down = 'ArrowDown',
  Enter = 'Enter',
  Esc = 'Escape',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  Left = 'ArrowLeft',
  Right = 'ArrowRight',
  Space = ' ',
  Tab = 'Tab',
  Up = 'ArrowUp',
}
export interface ListItem {
  description: string;
  to?: string;
  value: string;
}
export type NodeEnvironment = 'development' | 'local' | 'onboarding' | 'production' | 'staging' | 'test';

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export type ThenArg<T> = T extends PromiseLike<infer U> ? U :
  T extends ((...args: unknown[]) => PromiseLike<infer V>) ? V :
    T;

export type PropsWithOnlyChildren = PropsWithChildren<Record<never, never>>;

/**
 * Helper type to apply `NonNullable` to all fields in `TObject`
 */
export type NonNullableFields<TObject extends object> = {
  [K in keyof TObject]: NonNullable<TObject[K]>;
};
